import { BaseMaintenanceBloc } from "./bloc.base";

export class BoxMaintenanceBloc extends BaseMaintenanceBloc {
}

